import TableHeader from '@/components/table/tableHeader';
import { useResponsive } from '@/hooks/use-responsive';
import { useRef } from 'react';
import styled from 'styled-components';

import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import useStickyFooter from '@/hooks/useStickyFooter';
import { CommitmentForecastValueDto } from '../../../../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';
import TableSumFooter from './tableSumFooter';

interface CommitmentTableProps {
  tableData: CommitmentForecastValueDto[];
  tableHeaderColumns: TableColumns[];
  loading: boolean;
  columnWidth: number;
  openOpportunityDetailsPage: (id: string) => void;
}

const CommitmentTable = ({ tableData, tableHeaderColumns, loading, columnWidth, openOpportunityDetailsPage }: CommitmentTableProps) => {
  const { isMobile } = useResponsive();

  const containerRef = useRef<HTMLDivElement | null>(null);
  const footerRef = useRef<HTMLDivElement | null>(null);

  useStickyFooter(containerRef, footerRef);

  return (
    <>
      {isMobile ? (
        <>{loading ? <Loader /> : <MobileTable tableData={tableData} openOpportunityDetailsPage={openOpportunityDetailsPage} />}</>
      ) : (
        <>
          <CustomTableHeader refetch={() => {}} withOutSort columns={tableHeaderColumns} />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <>
                <TableBody tableData={tableData} columnWidth={columnWidth} openOpportunityDetailsPage={openOpportunityDetailsPage} />
                <TableSumFooterWrapper ref={footerRef}>
                  <TableSumFooter tableData={tableData} columnWidth={columnWidth} />
                </TableSumFooterWrapper>
                <div ref={containerRef}></div>
              </>
            )}
          </TableBodyWrapper>
        </>
      )}
    </>
  );
};

export default CommitmentTable;

const CustomTableHeader = styled(TableHeader)`
  position: static;

  #tableColumnTitle {
    flex-basis: auto;
  }
`;

const TableSumFooterWrapper = styled.div`
  &.sticky {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
`;
